// extracted by mini-css-extract-plugin
export default {"container":"S01_container__SwdA-","wrapper":"S01_wrapper__kdyuU","arrow":"S01_arrow__TeNhT","slowBounceUp":"S01_slowBounceUp__Qc0RW"};